import { boolean, object, string, array, TypeOf, mixed } from 'yup'
import { DisplayUnit } from 'types/generated/graphql'

export const EnqueteFormSchema = object({
  title: string().required('タイトルは必須です').default(''),
  question: string().required('質問文は必須です').default(''),
  deadline: string(),
  optionsCsv: array()
    .test(
      'required_two',
      '選択肢は2つ以上必要です',
      (values) => Array.isArray(values) && values.length >= 2
    )
    .test(
      'max_length',
      '選択肢にセットできる文字数の合計は180字が上限です。文字数合計を180字以内にしてください。',
      (values) =>
        Array.isArray(values) &&
        values.length >= 2 &&
        values.reduce(
          (prev, current) => String(prev ?? '') + String(current ?? '')
        ).length <= 180
    )
    .default(['']),
  imageUrl: string().ensure().default(''),
  published: boolean().default(false),
  displayUnit: mixed()
    .oneOf(
      [DisplayUnit.Percentage, DisplayUnit.Vote],
      '「％」か「票数」を選択してください'
    )
    .default(DisplayUnit.Percentage),
}).defined()

export type EnqueteFormValues = TypeOf<typeof EnqueteFormSchema>
